import { render } from "./VisitanteCadastro.vue?vue&type=template&id=106d8c87&scoped=true"
import script from "./VisitanteCadastro.vue?vue&type=script&lang=js"
export * from "./VisitanteCadastro.vue?vue&type=script&lang=js"

import "./VisitanteCadastro.vue?vue&type=style&index=0&id=106d8c87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106d8c87"]])

export default __exports__